// store/index.js
import { createStore } from "vuex";
import companiesModule from './modules/companies';
import loginCompany from "./modules/loginCompany";
import loginMinistry from "./modules/loginMinistry";

export default createStore({
    modules: {
        companies: companiesModule,
        loginCompany: loginCompany,
        loginMinistry: loginMinistry
      },

});
